import { Component, Input, OnInit } from '@angular/core';
import { Avaliacao } from 'src/app/core/avaliacao';
import { DataUtilService } from '../../../services/commons/data-util.service';

@Component({
  selector: 'dados-avaliacao',
  templateUrl: './dados-avaliacao.component.html',
  styleUrls: ['./dados-avaliacao.component.css']
})
export class DadosAvaliacaoComponent implements OnInit {

  @Input() avaliacao:Avaliacao;

  constructor(private dataUtilService: DataUtilService) { }

  ngOnInit() {
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

}
